import React from 'react';
import Header from '../Header';
import ContactUsFooter from '../ContactUs/ContactUsFooter';
import './Fluoride.css';

const Fluoride = () => {
    const pricing = [
        { type: "Fluoride Gel", price: "₱1,500 - ₱2,000" },
        { type: "Fluoride Varnish", price: "₱1,500 - ₱2,000" },
    
    ];

    return (
        <>
        <Header/>
        <div className="fluoride-container">
            <div className="fluoride-content">
                <h1>FLUORIDE</h1>
                <p>
                Fluoride strengthens teeth and reduces your risk of cavities by approximately 25%. Specifically, fluoride: 
                Remineralizes your tooth enamel. Reverses early tooth decay.
                </p>
                <h2>Pricing</h2>
                <table className="fluoride-table">
                        <thead>
                            <tr>
                                <th>Type of Surgery</th>
                                <th>Price</th>
                            </tr>
                        </thead>
                        <tbody>
                            {pricing.map((item, index) => (
                                <tr key={index}>
                                    <td>{item.type}</td>
                                    <td>{item.price}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
            <ContactUsFooter />
        </>
    );
};

export default Fluoride;